import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// Your Firebase project config (safe to expose)
const firebaseConfig = {
  apiKey: "AIzaSyDgVIfOJuwB1wevJyAc4hlgxK63zyD_L8U",
  authDomain: "party-witty-web-app.firebaseapp.com",
  projectId: "party-witty-web-app",
  storageBucket: "party-witty-web-app.firebasestorage.app", // ✅ fixed
  messagingSenderId: "512799076223",
  appId: "1:512799076223:web:49111c755f4ddb7f18744a",
  measurementId: "G-XNQE78XKTX",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export messaging instance
export const messaging = getMessaging(app);
